import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import Icon from '../AppIcon';
import Button from './Button';
// import logo from '' // Adjust the path as necessary


const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { name: 'Home', path: '/homepage-royal-welcome-hub', icon: 'Home' },
    { name: 'Games', path: '/games-showcase-gaming-palace', icon: 'Gamepad2' },
    { name: 'About', path: '/about-dynasty-brand-heritage', icon: 'Crown' },
    { name: 'Winners', path: '/success-stories-gallery-winner-showcase', icon: 'Trophy' },
  ];

  const secondaryItems = [
    { name: 'Contact', path: '/vip-contact-suite-whats-app-hub', icon: 'Whatsapp' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/+917704070169?text=Hello! I would like to know more about Nitin Online Hub gaming services.', '_blank');
  };

  return (
    <>
      <header className={`fixed top-0 left-0 right-0 z-header transition-royal ${isScrolled ? 'bg-background/95 backdrop-blur-royal shadow-subtle border-b border-border' : 'bg-transparent'}`}>
        <div className="w-full">
          <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
            {/* Logo */}
            <Link to="/homepage-royal-welcome-hub" className="flex items-center space-x-3 hover:opacity-80 transition-royal" onClick={closeMobileMenu}>
              <div className="relative">
                <img src='/assets/images/logo.png' alt="Nitin Online Hub Logo" className="h-10 w-auto object-contain" />
              </div>

              <div className="hidden sm:block">
                <h1 className="text-xl font-heading font-bold text-gradient-royal">
                  Nitin
                </h1>
                <p className="text-xs text-text-secondary font-body -mt-1">
                  Online Hub
                </p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-1">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  className={`flex items-center space-x-2 px-4 py-2 rounded-button text-sm font-medium transition-royal ${
                    isActivePath(item?.path)
                      ? 'bg-primary text-primary-foreground shadow-royal'
                      : 'text-text-primary hover:bg-muted hover:text-primary'
                  }`}
                >
                  <Icon name={item?.icon} size={16} />
                  <span>{item?.name}</span>
                </Link>
              ))}
            </nav>

            {/* Desktop Actions */}
            <div className="hidden lg:flex items-center space-x-3">
              <Link
                to="/vip-contact-suite-whats-app-hub"
                className={`flex items-center space-x-2 px-3 py-2 rounded-button text-sm font-medium transition-royal ${
                  isActivePath('/vip-contact-suite-whats-app-hub')
                    ? 'text-primary' :'text-text-secondary hover:text-primary'
                }`}
              >
                {/* <FaW size={16} /> */}
                <span>Contact</span>
              </Link>
              
              <Button
                variant="default"
                size="sm"
                onClick={handleWhatsAppClick}
                iconPosition="left"
                className="animate-pulse-golden hover:animate-none bg-gradient-royal hover:shadow-glow flex items-center"
              >
                <FaWhatsapp size={16} className="mr-2" />
                WhatsApp Expert
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={toggleMobileMenu}
              className="lg:hidden p-2 rounded-button text-text-primary hover:bg-muted hover:text-primary transition-royal"
              aria-label="Toggle mobile menu"
            >
              <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={24} />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-background/98 backdrop-blur-royal border-t border-border shadow-subtle">
            <div className="px-4 py-4 space-y-2">
              {/* Mobile Navigation Items */}
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={closeMobileMenu}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-card text-base font-medium transition-royal ${
                    isActivePath(item?.path)
                      ? 'bg-primary text-primary-foreground shadow-royal'
                      : 'text-text-primary hover:bg-muted hover:text-primary'
                  }`}
                >
                  <Icon name={item?.icon} size={20} />
                  <span>{item?.name}</span>
                </Link>
              ))}

              {/* Mobile Secondary Items */}
              {secondaryItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={closeMobileMenu}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-card text-base font-medium transition-royal ${
                    isActivePath(item?.path)
                      ? 'bg-primary text-primary-foreground shadow-royal'
                      : 'text-text-primary hover:bg-muted hover:text-primary'
                  }`}
                >
                  {/* <FaWhatsapp size={20} /> */}
                  <span>{item?.name}</span>
                </Link>
              ))}

              {/* Mobile WhatsApp CTA */}
              <div className="pt-4 border-t border-border">
                <Button
                  variant="default"
                  size="default"
                  onClick={() => {
                    handleWhatsAppClick();
                    closeMobileMenu();
                  }}
                  iconPosition="left"
                  fullWidth
                  className="animate-pulse-golden hover:animate-none bg-gradient-royal hover:shadow-glow flex items-center"
                >
                  <FaWhatsapp size={20} className="mr-2" />
                  Get ur Gaming ID
                </Button>
              </div>

              {/* Mobile Brand Info */}
              <div className="pt-4 text-center">
                <p className="text-sm text-text-secondary font-body">
                  India's Most Trusted Gaming Platform
                </p>
                <div className="flex items-center justify-center space-x-4 mt-2">
                  <div className="flex items-center space-x-1">
                    <Icon name="Shield" size={14} color="var(--color-success)" />
                    <span className="text-xs text-text-muted">Secure</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Icon name="Clock" size={14} color="var(--color-primary)" />
                    <span className="text-xs text-text-muted">24/7 Support</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Icon name="Users" size={14} color="var(--color-accent)" />
                    <span className="text-xs text-text-muted">10K+ Players</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </header>
      {/* Spacer to prevent content overlap */}
      <div className="h-16"></div>
    </>
  );
};

export default Header;